export const ONLINE_ADMISSION_URL = "https://admission.bu.edu.so";

// Update this URL if Benadir University changes the live online admission portal.
